import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import modalReducer from './modalSlice';
import organizationReducer from './organizationSlice';
import questionReducer from './questionSlice';
import progressQueueReducer from './progressQueueSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    modals: modalReducer,
    organization: organizationReducer,
    questions: questionReducer,
    progressQueue: progressQueueReducer,
  },
});

export default store;
